const PREFIX = '@DOC-IT//';

export const CHANGE_PAGE_TITLE = `${PREFIX}CHANGE-PAGE-TITLE`;
export const CHANGE_COLOR_FORMAT = `${PREFIX}CHANGE-COLOR-FORMAT`;
export const TOGGLE_DRAWER = `${PREFIX}TOGGLE_DRAWER`;
export const TOGGLE_SEARCH = `${PREFIX}TOGGLE_SEARCH`;
export const TOGGLE_SIDEBAR = `${PREFIX}TOGGLE_SIDEBAR`;
export const TOGGLE_TOC = `${PREFIX}TOGGLE_TOC`;
export const SHOW_BANNER = `${PREFIX}SHOW_BANNER`;
export const HIDE_BANNER = `${PREFIX}HIDE_BANNER`;
